export default __webpack_public_path__ + "static/media/particle.b14ff166.gif";